export default "//static.tradera.net/touchweb/static/output/images/qr-code-appstore.754f2d62.svg";